import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import lPrompt from '@/components/l-prompt'
import { lLoading } from '@/components/l-loading'
import version from '@/utils/version'
import { goPage } from '@/utils/bridge'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    ...routes,
  ],
})

router.beforeEach((to, from, next) => {
  if ((to.meta && to.meta.noauth) || store.state.user.user) {
    // 获取课时信息
    store.commit('course/SET_CURRENT_LESSON')
    next()
  } else {
    if (to.query && to.query.code) {
      lLoading.show(document.readyState)
      setTimeout(() => {
        window.$dayuan1997.getUser().then(function (data) {
          // 获取userId
          if (!data || !data.token) {
            localStorage.removeItem('USER')

            if (version.isLILYTribeAPP()) {
              goPage(goPage.PageName.LOGIN) // 重新登录
            } else {
              // -----END--------app内嵌加入代码
              window.$dayuan1997.login(
                encodeURIComponent(
                  window.location.protocol + '//' + window.location.host
                )
              )
            }
          } else {
            localStorage.setItem('USER', JSON.stringify(data))
            store.dispatch('user/SET_USER').then(() => {
              store.commit('course/SET_CURRENT_LESSON')
              next()
            })
            next()
          }
        })
        lLoading.hide()
      }, 2000)
    } else {
      if (localStorage.getItem('USER')) {
        store.commit('user/SET_USER', JSON.parse(localStorage.getItem('USER')))
        store.commit('course/SET_CURRENT_LESSON')
        next()
      } else {
        lPrompt({
          message: '用户信息已失效，请重新登录！',
          successTxt: '确定',
          successFn: function () {
            localStorage.removeItem('USER')

            if (version.isLILYTribeAPP()) {
              goPage(goPage.PageName.LOGIN) // 重新登录
            } else {
              // -----END--------app内嵌加入代码
              window.$dayuan1997.login(
                encodeURIComponent(
                  window.location.protocol + '//' + window.location.host
                )
              )
            }
          },
        })
      }
    }
  }
})

export default router
